export const COMMITTEES_BASE_PATH = "/people/membership-services/committees" as const;
export const LEGACY_COMMITTEES_BASE_PATH = "/people/membership-services/legacy-committees" as const;
export const LEGACY_COMMITTEES_ALL_PATH = "/people/membership-services/legacy-committees/all" as const;
export const COMMITTEES_ACTIVE_PATH = "/people/membership-services/committees/active" as const;
export const COMMITTEES_ALL_PATH = "/people/membership-services/committees/all" as const;
export const COMMITTEE_FROM_ALL_PARAM = "from";
export const COMMITTEE_FROM_ALL_VALUE = "all";
export const COMMITTEE_PARTICIPATION_PARAM = "participation";
export const NATIONAL_SECTION_NAME = "National Section";
export const NATIONAL_SECTION_LEGACY_ID = "PGA";
export const COMMITTEE_ASSIGNMENTS_PAGE_SIZE = 100;
export const DEFAULT_COMMITTEE_ASSIGNMENT_TITLE = "Committee Member";

type NationalSectionCandidate = { id: string; name: string; legacyId?: string | null };

export function resolveNationalSectionId(sections: NationalSectionCandidate[] | undefined): string | undefined {
  if (!sections?.length) return undefined;

  return sections.find(
    (section) => section.name === NATIONAL_SECTION_NAME || section.legacyId === NATIONAL_SECTION_LEGACY_ID
  )?.id;
}

export function isNationalSection(section: { name: string; legacyId?: string | null } | null | undefined): boolean {
  if (!section) return false;
  return section.name === NATIONAL_SECTION_NAME || section.legacyId === NATIONAL_SECTION_LEGACY_ID;
}

export function sectionOperationsCommitteesPath(sectionId: string): string {
  return `/sections/${sectionId}/operations/committees`;
}

export function nationalCommitteePath(committeeId: string): string {
  return `${COMMITTEES_BASE_PATH}/${committeeId}`;
}

export function sectionOperationsCommitteePath(sectionId: string, committeeId: string): string {
  return `${sectionOperationsCommitteesPath(sectionId)}/${committeeId}`;
}

export function nationalCommitteeCatalogPath(
  catalogTab: "active" | "all"
): typeof COMMITTEES_ACTIVE_PATH | typeof COMMITTEES_ALL_PATH {
  return catalogTab === "all" ? COMMITTEES_ALL_PATH : COMMITTEES_ACTIVE_PATH;
}

export function nationalCommitteeDetailPath(committeeId: string, catalogTab: "active" | "all" = "active"): string {
  const path = nationalCommitteePath(committeeId);
  if (catalogTab === "all") {
    return `${path}?${COMMITTEE_FROM_ALL_PARAM}=${COMMITTEE_FROM_ALL_VALUE}`;
  }
  return path;
}
